import { EditProps } from 'react-admin';
import { CustomEdit } from '../../components';
import Form from './form';

export default function PagesEdit(props: EditProps) {
  return (
    <CustomEdit {...props}>
      <Form />
    </CustomEdit>
  );
}
